import { tsValidateArray, tsValidateResult, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { referencablePropTypes } from './types.js';
import { referencablePropType_ConflictMap } from './consts.js';
function collectConflictingPropTypes(prototype) {
    const conflicts = [];
    for (let i = 0; i < prototype.types.length; i++) {
        const type = prototype.types[i];
        const conflictingTypes = referencablePropType_ConflictMap[type];
        for (let j = i + 1; j < prototype.types.length; j++) {
            if (conflictingTypes.includes(prototype.types[j])) {
                let conflict = conflicts.find(i => i.type === type);
                if (!conflict) {
                    conflict = { type, conflicts: [] };
                    conflicts.push(conflict);
                }
                conflict.conflicts.push(prototype.types[j]);
            }
        }
    }
    return conflicts.length ? conflicts : undefined;
}
const Validator_ReferencablePrototype = (prototype) => {
    if (!prototype)
        return 'Missing field';
    //Assert no conflicting types
    const typeConflicts = collectConflictingPropTypes(prototype);
    if (typeConflicts)
        return {
            types: typeConflicts.reduce((acc, conflict) => {
                acc[conflict.type] = `Conflicting with following types: ${conflict.conflicts.join(', ')}`;
                return acc;
            }, {})
        };
    //Return validation
    return tsValidateResult(prototype, {
        id: tsValidateUniqueId,
        types: tsValidateArray(tsValidateValue([...referencablePropTypes])),
    });
};
export const Validator_ReferencablePrototypes = tsValidateArray(Validator_ReferencablePrototype);
//# sourceMappingURL=validation.js.map